import React, {useEffect, useState} from 'react'
import { KTSVG } from "../../../../_metronic/helpers"
import { useIntl } from "react-intl"
import { TComponentSearch } from "./_types"
import {useSearchHistory} from './hook/useSearchHistory'

const ComponentSearch: React.FC<TComponentSearch> = ({ value, setValue, storageKey }) => {
    const intl = useIntl()
    const { history, sync } = useSearchHistory(storageKey)
    const [isFocused, setIsFocused] = useState(false)
    const isDropdownVisible = isFocused && !value && history.length > 0
    const handleChange = (event: React.ChangeEvent<HTMLInputElement>) => setValue(event.target.value)
    const handleClick = () => setValue("")
    useEffect(() => {
        if (!value) {
            sync()
        }
    }, [value])
    return <div className="componentSearch_container">
        <input
            className="form-control form-control-solid componentSearch"
            type="text"
            name="search"
            value={value ?? ""}
            onChange={handleChange}
            placeholder={intl.formatMessage({ id: "SEARCH.PLACEHOLDER" })}
            autoComplete="off"
            onFocus={() => {
                sync()
                setIsFocused(true)
            }}
            onBlur={()=> {
                setTimeout(()=>setIsFocused(false), 150)
            }}
        />
        {isDropdownVisible && (
            <div className="componentSearch_dropdown">
                {history.map((item, index) => (
                    <div
                        key={index}
                        className="componentSearch_item"
                        onMouseDown={() => {
                            setValue(item)
                            setIsFocused(false)
                        }}
                    >
                        {item}
                    </div>
                ))}
            </div>
        )}
        {value.length ? <button type="button" className="componentSearch_button" onClick={handleClick}>
            <KTSVG path='/media/crm/icons/close.svg' />
        </button> : null}
    </div>
}


export default ComponentSearch